export default __webpack_public_path__ + "static/media/banner4.4cc02fec.png";